import block from '@/mixins/block'

export default {
  name: 'block_focus',
  mixins: [block],
  mounted () {
    if (this.$refs.video && this.$refs.video.length > 0) {
      this.observer = new IntersectionObserver(observables => {
        observables.forEach((observable, key) => {
          if (observable.intersectionRatio > 0.1) {
            observable.target.play()
          } else {
            observable.target.pause()
          }
        })
      }, {
        threshold: [0.1, 0.9]
      })
      this.$refs.video.forEach(video => {
        this.observer.observe(video)
      })
    }
  },
  beforeDestroy () {
    if (this.observer) {
      this.$refs.video.forEach(video => {
        this.observer.unobserve(video)
      })
    }
  }
}
